import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  DocumentDownloadResponse,
  DocumentExportResponse,
  DownloadRequest,
  ExportRequest,
  OperationStatus,
  DocumentDownloadParams,
  FileStatusInfo,
  FileStatusFailed,
} from '../types';
import { ComponentType } from '@angular/cdk/portal';

/**
 * @USER DOWNLOAD ACTIONS
 * */
const loadDocumentDownloads = () => props<{ params: DocumentDownloadParams }>();

const onLoadDocumentDownloadsSuccess = () =>
  props<{ downloadsData: DocumentDownloadResponse }>();

const initiateDownload = () =>
  props<{ downloadRequest: DownloadRequest; data: unknown }>();

const downloadStarted = () => props<{ status: OperationStatus }>();

const downloadSuccess = () => props<FileStatusInfo>();

const downloadFailure = () => props<FileStatusFailed>();

const openDownloadConfirmationDialog = () =>
  props<{
    component: () => ComponentType<unknown>;
    data: unknown;
  }>();

const getDocumentLink = () => props<{ documentId: string }>();

export const USER_DOWNLOAD_ACTIONS = createActionGroup({
  events: {
    downloadDialogConfirmed: emptyProps(),
    downloadDialogDismissed: emptyProps(),
    downloadFailure: downloadFailure(),
    downloadStarted: downloadStarted(),
    downloadSuccess: downloadSuccess(),
    getDocumentLink: getDocumentLink(),
    initiateDownload: initiateDownload(),
    loadDocumentDownloads: loadDocumentDownloads(),
    onLoadDocumentDownloadsSuccess: onLoadDocumentDownloadsSuccess(),
    openDownloadConfirmationDialog: openDownloadConfirmationDialog(),
  },
  source: '[User] Downloads',
});

/**
 * @USER DOWNLOAD ACTIONS END
 * */

/**
 * @USER EXPORT ACTIONS
 * */
const initiateExport = () =>
  props<{ exportRequest: ExportRequest; data: unknown }>();

const exportStarted = () => props<{ status: OperationStatus }>();

const exportSuccess = () => props<FileStatusInfo>();

const exportFailure = () => props<FileStatusFailed>();

const openExportConfirmationDialog = () =>
  props<{
    component: () => ComponentType<unknown>;
    data: unknown;
  }>();

const loadDocumentExports = () => props<{ params: DocumentDownloadParams }>();

const onLoadDocumentExportsSuccess = () =>
  props<{ exportsData: DocumentExportResponse }>();

export const USER_EXPORT_ACTIONS = createActionGroup({
  events: {
    exportDialogConfirmed: emptyProps(),
    exportDialogDismissed: emptyProps(),
    exportFailure: exportFailure(),
    exportStarted: exportStarted(),
    exportSuccess: exportSuccess(),
    initiateExport: initiateExport(),
    loadDocumentExports: loadDocumentExports(),
    onLoadDocumentExportsSuccess: onLoadDocumentExportsSuccess(),
    openExportConfirmationDialog: openExportConfirmationDialog(),
  },
  source: '[User] Exports',
});

/**
 * @USER DOWNLOADS ACTIONS END
 * */
